import React, { createContext, useContext, useState } from 'react'

export const UnitsContext = createContext(null)

export const useUnits = () => useContext(UnitsContext)

export const UnitsProvider = ({ children }) => {
  const [units, setUnits] = useState(null)

  return (
    <UnitsContext.Provider
      value={{ units, setUnits }}
    >
      {children}
    </UnitsContext.Provider>
  )
}
